import React, { useEffect, useState } from "react";
import { supabase } from "./supabaseClient";
import { format, addDays } from "date-fns";

const days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

function getMonday(date) {
  const d = new Date(date);
  const day = d.getDay();
  const diff = d.getDate() - day + (day === 0 ? -6 : 1);
  return new Date(d.setDate(diff));
}

export default function StaffRota() {
  const [weekStart, setWeekStart] = useState(getMonday(new Date()));
  const [assignments, setAssignments] = useState([]);
  const [user, setUser] = useState(null);
  const [employee, setEmployee] = useState(null);

  // Get logged-in user
  useEffect(() => {
    supabase.auth.getUser().then(async ({ data }) => {
      setUser(data?.user);
      if (data?.user) {
        // Fetch employee details
        const { data: empData } = await supabase
          .from("employees")
          .select("*")
          .eq("id", data.user.id)
          .single();
        setEmployee(empData);
      }
    });
  }, []);

  // Fetch assignments for this employee and week
  useEffect(() => {
    if (!user) return;
    supabase
      .from("rota_assignment")
      .select("*")
      .eq("employee_id", user.id)
      .eq("week_start", weekStart.toISOString().slice(0, 10))
      .then(({ data }) => setAssignments(data || []));
  }, [user, weekStart]);

  // Calculate total hours
  const totalHours = assignments.reduce((sum, a) => sum + (Number(a.hours) || 0), 0);

  return (
    <div>
      <h2>
        My Rota for week starting {format(weekStart, "dd/MM/yyyy")}
        <button onClick={() => setWeekStart(addDays(weekStart, -7))}>Prev</button>
        <button onClick={() => setWeekStart(addDays(weekStart, 7))}>Next</button>
      </h2>
      {employee && (
        <div style={{ marginBottom: 16, fontWeight: "bold" }}>
          {employee.full_name || employee.name}
        </div>
      )}
      <table className="rota-table">
        <thead>
          <tr>
            <th>Day</th>
            <th>Shift Name</th>
            <th>Start</th>
            <th>End</th>
            <th>Hours</th>
          </tr>
        </thead>
        <tbody>
          {days.map((day, dayIdx) => {
            const shifts = assignments.filter(a => a.day === dayIdx);
            if (shifts.length === 0) {
              return (
                <tr key={day}>
                  <td>{day}</td>
                  <td colSpan={4}>Off</td>
                </tr>
              );
            }
            // Show each shift as a separate row
            return shifts.map((shift, i) => (
              <tr key={day + i}>
                <td>{day}</td>
                <td>{shift.shift_name}</td>
                <td>{shift.shift_start}</td>
                <td>{shift.shift_end}</td>
                <td>{shift.hours || ""}</td>
              </tr>
            ));
          })}
        </tbody>
        <tfoot>
          <tr>
            <td colSpan={4} style={{ textAlign: "right", fontWeight: "bold" }}>
              Total Hours This Week:
            </td>
            <td style={{ fontWeight: "bold" }}>{totalHours}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
}